import React from 'react';
import { Button } from '../components/ui/Button';
import { WindIcon, ActivityIcon, UsersIcon, SunIcon, MoonIcon, CoffeeIcon, CheckIcon, ArrowRightIcon, MapPinIcon, CalendarIcon, SparklesIcon } from 'lucide-react';
export function SoulFlow() {
  const scrollToForm = () => {
    const element = document.getElementById('registration-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-[#333333] bg-[#F5F2EA]" data-id="element-2693">
      {/* 1. HERO SECTION */}
      <section className="relative min-h-screen flex flex-col items-center justify-center bg-[#2C3E2E] text-[#F5F2EA] px-4 py-20 overflow-hidden" data-id="element-2694">
        <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-2695">
          {/* Subtle texture or noise could go here, using CSS radial gradient for now */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/20 to-transparent" data-id="element-2696" />
        </div>

        <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto space-y-8 animate-fade-in-up" data-id="element-2697">
          {/* Logo Mark */}
          <div className="w-24 h-24 rounded-full border border-[#F5F2EA]/30 flex items-center justify-center mb-6" data-id="element-2698">
            <span className="font-serif text-3xl italic" data-id="element-2699">SF</span>
          </div>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight leading-none" data-id="element-2700">
            SOUL FLOW
          </h1>

          <p className="text-lg md:text-xl font-light tracking-wide opacity-90 max-w-lg" data-id="element-2701">
            A luxury yoga and wellness escape curated for intentional living
          </p>

          <div className="flex flex-col items-center space-y-2 py-6 border-t border-b border-[#F5F2EA]/20 w-full max-w-md" data-id="element-2702">
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2703">
              <CalendarIcon className="w-4 h-4" data-id="element-2704" />
              <span data-id="element-2705">April 10–13, 2026</span>
            </div>
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2706">
              <CalendarIcon className="w-4 h-4" data-id="element-2707" />
              <span data-id="element-2708">April 17–20, 2026</span>
            </div>
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2709">
              <CalendarIcon className="w-4 h-4" data-id="element-2710" />
              <span data-id="element-2711">April 24–27, 2026</span>
            </div>
          </div>

          <div className="inline-flex items-center px-3 py-1 border border-[#F5F2EA]/40 rounded-full text-xs tracking-[0.2em] uppercase" data-id="element-2712">
            Invitation Only
          </div>

          <div className="flex flex-col sm:flex-row gap-6 mt-8" data-id="element-2713">
            <button onClick={scrollToForm} className="px-8 py-4 bg-[#F5F2EA] text-[#2C3E2E] font-medium tracking-wide hover:bg-[#E0E0E0] transition-colors duration-300 min-w-[200px]" data-id="element-2714">
              PRE-REGISTER
            </button>
            <button onClick={() => document.getElementById('intro')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-8 py-4 bg-transparent border border-[#F5F2EA]/30 text-[#F5F2EA] font-medium tracking-wide hover:bg-[#F5F2EA]/10 transition-colors duration-300 min-w-[200px]" data-id="element-2715">
              EXPLORE THE EXPERIENCE
            </button>
          </div>
        </div>
      </section>

      {/* 2. WHAT IS SOUL FLOW */}
      <section id="intro" className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-2716">
        <div className="max-w-6xl mx-auto" data-id="element-2717">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24" data-id="element-2718">
            <div className="flex flex-col space-y-4" data-id="element-2719">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2720">
                01
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2721">Reset</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2722">
                Disconnect from the noise. Realign your nervous system through
                breath, silence, and grounding practices designed to strip away
                the unnecessary.
              </p>
            </div>
            <div className="flex flex-col space-y-4" data-id="element-2723">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2724">
                02
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2725">Rebuild</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2726">
                Cultivate resilience. Engage in strength, mobility, and
                controlled intensity to forge a body and mind capable of
                enduring grace.
              </p>
            </div>
            <div className="flex flex-col space-y-4" data-id="element-2727">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2728">
                03
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2729">Reconnect</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2730">
                Find your tribe. Experience the power of shared intention and
                community in a space curated for depth, presence, and authentic
                connection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. THE FLOW (ITINERARY) */}
      <section className="py-24 px-4 md:px-12 bg-[#9CAF9C]/20" data-id="element-2731">
        <div className="max-w-4xl mx-auto" data-id="element-2732">
          <div className="text-center mb-16" data-id="element-2733">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-4" data-id="element-2734">
              The Flow
            </h2>
            <p className="text-[#2C3E2E]/70 italic font-serif" data-id="element-2735">
              A curated rhythm for your days
            </p>
          </div>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-[#2C3E2E]/10 before:hidden md:before:block" data-id="element-2736">
            {/* Day 1 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2737">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2738">
                <span className="text-xs font-serif" data-id="element-2739">I</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2740">
                <div className="flex items-center justify-between mb-2" data-id="element-2741">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2742">
                    Arrival & Grounding
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-2743">
                    Day One
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-2744">
                  <li className="flex items-center" data-id="element-2745">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2746"></span>
                    Private transfers
                  </li>
                  <li className="flex items-center" data-id="element-2747">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2748"></span>
                    Intentional welcome
                  </li>
                  <li className="flex items-center" data-id="element-2749">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2750"></span>
                    Orientation & opening ceremony
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 2 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2751">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2752">
                <span className="text-xs font-serif" data-id="element-2753">II</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2754">
                <div className="flex items-center justify-between mb-2" data-id="element-2755">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2756">
                    Flow & Recharge
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-2757">
                    Day Two
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-2758">
                  <li className="flex items-center" data-id="element-2759">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2760"></span>
                    Sunrise movement
                  </li>
                  <li className="flex items-center" data-id="element-2761">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2762"></span>
                    Nourishing meals
                  </li>
                  <li className="flex items-center" data-id="element-2763">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2764"></span>
                    Breakout sessions
                  </li>
                  <li className="flex items-center" data-id="element-2765">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2766"></span>
                    Sunset yoga & meditation
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 3 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2767">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2768">
                <span className="text-xs font-serif" data-id="element-2769">III</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2770">
                <div className="flex items-center justify-between mb-2" data-id="element-2771">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2772">
                    Integrate & Release
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-2773">
                    Day Three
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-2774">
                  <li className="flex items-center" data-id="element-2775">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2776"></span>
                    Morning practice
                  </li>
                  <li className="flex items-center" data-id="element-2777">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2778"></span>
                    Reflection & community
                  </li>
                  <li className="flex items-center" data-id="element-2779">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2780"></span>
                    Closing ritual
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. WHAT'S INCLUDED */}
      <section className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-2781">
        <div className="max-w-5xl mx-auto" data-id="element-2782">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-2783">
            <div data-id="element-2784">
              <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-8" data-id="element-2785">
                Inclusions
              </h2>
              <div className="space-y-6" data-id="element-2786">
                {[{
                icon: <SparklesIcon className="w-5 h-5" data-id="element-2787" />,
                text: '5-star all-inclusive accommodations'
              }, {
                icon: <MapPinIcon className="w-5 h-5" data-id="element-2788" />,
                text: 'Signature ground transportation'
              }, {
                icon: <ActivityIcon className="w-5 h-5" data-id="element-2789" />,
                text: 'Daily yoga, mobility & movement sessions'
              }, {
                icon: <WindIcon className="w-5 h-5" data-id="element-2790" />,
                text: 'Breathwork, meditation & wellness seminars'
              }, {
                icon: <UsersIcon className="w-5 h-5" data-id="element-2791" />,
                text: 'Curated community experience'
              }].map((item, idx) => <div key={idx} className="flex items-center space-x-4 group" data-id="element-2792">
                    <div className="w-10 h-10 rounded-full bg-[#2C3E2E]/5 flex items-center justify-center text-[#2C3E2E] group-hover:bg-[#2C3E2E] group-hover:text-[#F5F2EA] transition-colors duration-300" data-id="element-2793">
                      {item.icon}
                    </div>
                    <span className="text-lg font-light text-[#333333]" data-id="element-2794">
                      {item.text}
                    </span>
                  </div>)}
              </div>
              <p className="mt-8 text-sm text-[#333333]/50 italic border-l-2 border-[#2C3E2E]/20 pl-4" data-id="element-2795">
                Note: Flights are arranged independently for flexibility and
                ease.
              </p>
            </div>
            <div className="relative h-[500px] w-full bg-[#2C3E2E]/5 rounded-sm overflow-hidden" data-id="element-2796">
              {/* Placeholder for an abstract/calm image */}
              <div className="absolute inset-0 bg-[#8FA893]/30 mix-blend-multiply" data-id="element-2797" />
              <img src="https://images.unsplash.com/photo-1545205597-3d9d02c29597?q=80&w=2070&auto=format&fit=crop" alt="Calm wellness atmosphere" className="w-full h-full object-cover opacity-80 grayscale-[20%]" data-id="element-2798" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. MORE THAN YOGA */}
      <section className="py-24 px-4 md:px-12 bg-[#2C3E2E] text-[#F5F2EA]" data-id="element-2799">
        <div className="max-w-6xl mx-auto" data-id="element-2800">
          <div className="text-center mb-16" data-id="element-2801">
            <h2 className="font-serif text-4xl md:text-5xl mb-4" data-id="element-2802">
              More Than Yoga
            </h2>
            <p className="text-[#F5F2EA]/70 font-light max-w-2xl mx-auto" data-id="element-2803">
              A holistic approach to well-being, integrating ancient wisdom with
              modern science.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#F5F2EA]/10 border border-[#F5F2EA]/10" data-id="element-2804">
            {[{
            title: 'Yoga & Flow',
            desc: 'Movement to align body and breath.'
          }, {
            title: 'Breathwork & Meditation',
            desc: 'Tools to master your nervous system.'
          }, {
            title: 'Strength & HIIT',
            desc: 'Build resilience through controlled intensity.'
          }, {
            title: 'Mobility & Recovery',
            desc: 'Restore range of motion and ease.'
          }, {
            title: 'Nutrition & Mindful Eating',
            desc: 'Fuel your body with intention.'
          }, {
            title: 'Community Rituals',
            desc: 'Connect deeply with like-minded souls.'
          }].map((tile, idx) => <div key={idx} className="bg-[#2C3E2E] p-8 md:p-12 hover:bg-[#2C3E2E]/80 transition-colors duration-300 group" data-id="element-2805">
                <h3 className="font-serif text-2xl mb-2 group-hover:text-[#8FA893] transition-colors" data-id="element-2806">
                  {tile.title}
                </h3>
                <p className="text-[#F5F2EA]/60 font-light text-sm" data-id="element-2807">
                  {tile.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. INVESTMENT */}
      <section className="py-24 px-4 md:px-12 bg-[#8FA893]/30" data-id="element-2808">
        <div className="max-w-5xl mx-auto" data-id="element-2809">
          <div className="text-center mb-16" data-id="element-2810">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-4" data-id="element-2811">
              Investment
            </h2>
            <p className="text-[#2C3E2E]/70 font-light" data-id="element-2812">
              Secure your place in the circle.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-2813">
            {/* Single Occupancy */}
            <div className="bg-[#F5F2EA] p-8 md:p-12 border border-[#2C3E2E]/5 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-500" data-id="element-2814">
              <h3 className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase mb-4" data-id="element-2815">
                Private Sanctuary
              </h3>
              <h4 className="font-serif text-3xl text-[#2C3E2E] mb-2" data-id="element-2816">
                Single Occupancy
              </h4>
              <div className="text-4xl font-light text-[#2C3E2E] mb-8" data-id="element-2817">
                $2,199 <span className="text-base opacity-50" data-id="element-2818">USD</span>
              </div>
              <ul className="space-y-3 text-sm text-[#333333]/70 mb-8 w-full text-left pl-8 md:pl-12" data-id="element-2819">
                <li className="flex items-center" data-id="element-2820">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2821" /> Private
                  king suite
                </li>
                <li className="flex items-center" data-id="element-2822">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2823" /> En-suite
                  luxury bath
                </li>
                <li className="flex items-center" data-id="element-2824">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2825" /> Full
                  retreat access
                </li>
              </ul>
              <button onClick={scrollToForm} className="w-full py-4 border border-[#2C3E2E] text-[#2C3E2E] hover:bg-[#2C3E2E] hover:text-[#F5F2EA] transition-all duration-300 uppercase tracking-widest text-xs font-bold" data-id="element-2826">
                Select Single
              </button>
            </div>

            {/* Double Occupancy */}
            <div className="bg-[#F5F2EA] p-8 md:p-12 border border-[#2C3E2E]/5 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-500 relative overflow-hidden" data-id="element-2827">
              <div className="absolute top-0 right-0 bg-[#2C3E2E] text-[#F5F2EA] text-[10px] uppercase tracking-widest px-3 py-1" data-id="element-2828">
                Best Value
              </div>
              <h3 className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase mb-4" data-id="element-2829">
                Shared Experience
              </h3>
              <h4 className="font-serif text-3xl text-[#2C3E2E] mb-2" data-id="element-2830">
                Double Occupancy
              </h4>
              <div className="text-4xl font-light text-[#2C3E2E] mb-8" data-id="element-2831">
                $1,599 <span className="text-base opacity-50" data-id="element-2832">USD</span>
              </div>
              <ul className="space-y-3 text-sm text-[#333333]/70 mb-8 w-full text-left pl-8 md:pl-12" data-id="element-2833">
                <li className="flex items-center" data-id="element-2834">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2835" /> Shared
                  luxury suite
                </li>
                <li className="flex items-center" data-id="element-2836">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2837" /> Two
                  queen beds
                </li>
                <li className="flex items-center" data-id="element-2838">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-2839" /> Full
                  retreat access
                </li>
              </ul>
              <button onClick={scrollToForm} className="w-full py-4 bg-[#2C3E2E] text-[#F5F2EA] hover:bg-[#2C3E2E]/90 transition-all duration-300 uppercase tracking-widest text-xs font-bold" data-id="element-2840">
                Select Double
              </button>
            </div>
          </div>

          <div className="mt-12 text-center text-sm text-[#2C3E2E]/60 font-light space-x-4" data-id="element-2841">
            <span data-id="element-2842">Limited capacity</span>
            <span data-id="element-2843">•</span>
            <span data-id="element-2844">Curated cohort</span>
            <span data-id="element-2845">•</span>
            <span data-id="element-2846">First-come, invitation-based</span>
          </div>
        </div>
      </section>

      {/* 7. WHO THIS IS FOR */}
      <section className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-2847">
        <div className="max-w-3xl mx-auto text-center" data-id="element-2848">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2C3E2E] mb-12" data-id="element-2849">
            Is Soul Flow for you?
          </h2>
          <div className="space-y-6 text-left md:text-center" data-id="element-2850">
            {['You want to reset without disconnecting from luxury', 'You value wellness without extremes', 'You want community without noise', 'You want intention, not performance'].map((item, idx) => <div key={idx} className="flex items-center md:justify-center space-x-4 text-lg md:text-xl font-light text-[#333333]/80" data-id="element-2851">
                <div className="w-6 h-6 rounded-full border border-[#2C3E2E]/30 flex items-center justify-center shrink-0" data-id="element-2852">
                  <CheckIcon className="w-3 h-3 text-[#2C3E2E]" data-id="element-2853" />
                </div>
                <span data-id="element-2854">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. FINAL CTA & FORM */}
      <section id="registration-form" className="py-24 px-4 md:px-12 bg-[#2C3E2E] text-[#F5F2EA]" data-id="element-2855">
        <div className="max-w-xl mx-auto" data-id="element-2856">
          <div className="text-center mb-12" data-id="element-2857">
            <h2 className="font-serif text-4xl md:text-5xl mb-4" data-id="element-2858">
              Your reset begins here.
            </h2>
            <p className="text-[#F5F2EA]/60 font-light" data-id="element-2859">
              Limited availability · Invitation only
            </p>
          </div>

          <form className="space-y-6 bg-[#F5F2EA]/5 p-8 md:p-12 rounded-sm border border-[#F5F2EA]/10" data-id="element-2860">
            <div className="space-y-2" data-id="element-2861">
              <label htmlFor="name" className="text-xs uppercase tracking-widest opacity-70" data-id="element-2862">
                Full Name
              </label>
              <input type="text" id="name" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20" placeholder="Enter your name" data-id="element-2863" />
            </div>

            <div className="space-y-2" data-id="element-2864">
              <label htmlFor="email" className="text-xs uppercase tracking-widest opacity-70" data-id="element-2865">
                Email Address
              </label>
              <input type="email" id="email" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20" placeholder="Enter your email" data-id="element-2866" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2867">
              <div className="space-y-2" data-id="element-2868">
                <label htmlFor="date" className="text-xs uppercase tracking-widest opacity-70" data-id="element-2869">
                  Preferred Date
                </label>
                <select id="date" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors text-[#F5F2EA] [&>option]:text-[#333333]" data-id="element-2870">
                  <option data-id="element-2871">April 10–13, 2026</option>
                  <option data-id="element-2872">April 17–20, 2026</option>
                  <option data-id="element-2873">April 24–27, 2026</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-2874">
                <label htmlFor="occupancy" className="text-xs uppercase tracking-widest opacity-70" data-id="element-2875">
                  Occupancy
                </label>
                <select id="occupancy" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors text-[#F5F2EA] [&>option]:text-[#333333]" data-id="element-2876">
                  <option data-id="element-2877">Single Occupancy ($2199)</option>
                  <option data-id="element-2878">Double Occupancy ($1599)</option>
                </select>
              </div>
            </div>

            <div className="space-y-2" data-id="element-2879">
              <label htmlFor="notes" className="text-xs uppercase tracking-widest opacity-70" data-id="element-2880">
                Optional Notes
              </label>
              <textarea id="notes" rows={3} className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20 resize-none" placeholder="Dietary restrictions, injuries, or intentions..." data-id="element-2881"></textarea>
            </div>

            <button type="button" className="w-full py-4 mt-8 bg-[#F5F2EA] text-[#2C3E2E] font-medium tracking-wide hover:bg-[#E0E0E0] transition-colors duration-300" data-id="element-2882">
              PRE-REGISTER FOR SOUL FLOW
            </button>
          </form>
        </div>
      </section>

      {/* 9. FOOTER (MINIMAL) */}
      <footer className="py-12 bg-[#F5F2EA] text-center border-t border-[#2C3E2E]/5" data-id="element-2883">
        <div className="space-y-4" data-id="element-2884">
          <div className="flex justify-center space-x-8 text-sm text-[#333333]/60 tracking-wide" data-id="element-2885">
            <a href="mailto:experience@destameet.com" className="hover:text-[#2C3E2E] transition-colors" data-id="element-2886">
              experience@destameet.com
            </a>
            <a href="https://instagram.com/destameet" target="_blank" rel="noopener noreferrer" className="hover:text-[#2C3E2E] transition-colors" data-id="element-2887">
              @destameet
            </a>
          </div>
          <p className="text-xs text-[#333333]/40 uppercase tracking-widest" data-id="element-2888">
            Part of DestaMeet
          </p>
        </div>
      </footer>
    </div>;
}